import { liveUpdateAttrs } from 'libs/contentful/utils';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import Eyebrow from 'components/shared/Eyebrow/Eyebrow';
import CTA, { isValidCta } from 'components/shared/CTA/CTA';

import { ContentBlockAlignment, OneColumnVariantProps } from './types';

import { cn } from 'utils/styles';

const OneColumnVariant = ({
  sys,
  eyebrow,
  eyebrowAlternateLogo,
  eyebrowChimeLogo,
  headline,
  copy,
  cta,
  alignment,
  className,
}: OneColumnVariantProps) => {
  const internalClassNames = {
    wrapper: cn('block sm:flex sm:flex-col sm:grid sm:grid-cols-2 sm:gap-12', className?.wrapper),
    outerContent: cn(
      'flex flex-col gap-12',
      {
        'order-1': alignment === ContentBlockAlignment.Right,
      },
      className?.outerContent,
    ),
    innerContent: cn('flex flex-col gap-8 justify-between', className?.innerContent),
    headline: {
      wrapper: cn('flex flex-col gap-2', className?.headline?.wrapper),
      content: cn('text-heading-md sm:text-heading-lg font-sans', className?.headline?.content),
    },
    copy: cn('font-serif text-lg empty:hidden', className?.copy),
    empty: cn(
      {
        'sm:order-0': alignment === ContentBlockAlignment.Right,
      },
      className?.empty,
    ),
  };

  const contentBlockTestId = `content-block-${alignment === ContentBlockAlignment.Left ? 'left' : 'right'}`;
  const emptyBlockTestId = `empty-block-${alignment === ContentBlockAlignment.Left ? 'right' : 'left'}`;

  return (
    <div className={internalClassNames.wrapper}>
      <div className={internalClassNames.outerContent} data-testid={contentBlockTestId}>
        <div className={internalClassNames.innerContent}>
          <div className={internalClassNames.headline.wrapper}>
            <Eyebrow
              sys={sys}
              eyebrowAlternateLogo={eyebrowAlternateLogo}
              eyebrowChimeLogo={eyebrowChimeLogo}
              eyebrowText={eyebrow}
              className="mb-0"
            />
            <div className={internalClassNames.headline.content} {...liveUpdateAttrs(sys?.id, 'headline')}>
              <RichTextHeadline headline={headline} level="h2" />
            </div>
          </div>

          <div className={internalClassNames.copy} {...liveUpdateAttrs(sys?.id, 'copy')}>
            <RichTextCopy copy={copy} />
          </div>
        </div>
        {isValidCta(cta) && <CTA cta={cta} />}
      </div>
      <div data-testid={emptyBlockTestId} className={internalClassNames.empty} />
    </div>
  );
};
export default OneColumnVariant;
